export default __webpack_public_path__ + "static/media/dummy-care-admin.91aee921.jpg";